import { render, staticRenderFns } from "./exhibition-info-boothImg.vue?vue&type=template&id=fc5d3c18&scoped=true&"
import script from "./exhibition-info-boothImg.vue?vue&type=script&lang=js&"
export * from "./exhibition-info-boothImg.vue?vue&type=script&lang=js&"
import style0 from "./exhibition-info-boothImg.vue?vue&type=style&index=0&id=fc5d3c18&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc5d3c18",
  null
  
)

export default component.exports